import { useEffect, useState } from 'react';

import { useShallow } from 'zustand/react/shallow';

import { metronome } from '@/shared/lib/metronome';

import { useRecordingStore } from './recording-store';

interface UseRecordingTimerReturn {
    elapsedTime: number;
}

export function useRecordingTimer(): UseRecordingTimerReturn {
    const [elapsedTime, setElapsedTime] = useState(0);

    const store = useRecordingStore(
        useShallow((state) => ({
            status: state.status,
            setElapsedTime: state.setElapsedTime,
        })),
    );

    useEffect(() => {
        store.setElapsedTime(elapsedTime);
    }, [store.status, elapsedTime, store.setElapsedTime]);

    useEffect(() => {
        let destroyMetronome: () => void;

        if (store.status === 'recording') {
            destroyMetronome = metronome(
                (elapsed: number) => {
                    setElapsedTime(elapsed);
                },
                1000,
                { seed: elapsedTime },
            );
        }

        return () => {
            destroyMetronome?.();
        };
    }, [store.status]);

    return { elapsedTime };
}
